
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Cascader 级联选择</h1>
<p>表单组件。适用于多层级数据的选择。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>可以使用v-model实现双向数据绑定。<code>value</code>数据类型为数组,为选中值的value路径的数组。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;10&quot;&gt;
        &lt;Col&gt;
            &lt;Cascader v-model=&quot;valueBase&quot; :data=&quot;data&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Cascader v-model=&quot;valueBase&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                valueBase: [],
                valueBase1: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="CC">
                <template slot="description"><p>设置 <code>size</code>属性可以控制尺寸大小，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置。</p>
</template>
                <template slot="title">尺寸 <a href="#CC" data-title="尺寸">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;10&quot;&gt;
        &lt;Col&gt;
            &lt;Cascader v-model=&quot;valueSizeMini&quot; :data=&quot;data&quot; size=&quot;mini&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Cascader v-model=&quot;valueSizeSmall&quot; :data=&quot;data&quot; size=&quot;small&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Cascader v-model=&quot;valueSizeDefault&quot; :data=&quot;data&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;Cascader v-model=&quot;valueSizeLarge&quot; :data=&quot;data&quot; size=&quot;large&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                valueSizeMini: [],
                valueSizeSmall: [],
                valueSizeDefault: [],
                valueSizeLarge: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="JY">
                <template slot="description"><p>设置 <code>disabled</code>属性可以实现禁用。单独给 <code>data</code>设置 <code>disabled</code>可以实现某项的禁用。</p>
</template>
                <template slot="title">禁用 <a href="#JY" data-title="禁用">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;10&quot;&gt;
        &lt;Col&gt;
            value: {{valueDisabled}}
            &lt;Cascader v-model=&quot;valueDisabled&quot; :data=&quot;data&quot; disabled&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            value: {{valueDisabled1}}
            &lt;Cascader v-model=&quot;valueDisabled1&quot; :data=&quot;data&quot;&gt;&lt;/Cascader&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                valueDisabled: [],
                valueDisabled1: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        disabled: true,
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                        disabled: true,
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="KQK">
                <template slot="description"><p>设置 <code>clearable</code>属性可以实现选中值之后点击清空按钮清空选中项。</p>
</template>
                <template slot="title">可清空 <a href="#KQK" data-title="可清空">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    value: {{value}}
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot; clearable&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="SZCSZ">
                <template slot="description"><p>设置初始值，默认选择对应的节点。</p>
</template>
                <template slot="title">设置初始值 <a href="#SZCSZ" data-title="设置初始值">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    value: {{value}}
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: ['beijing', 'haidian'],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="BTDCFFS">
                <template slot="description"><p>设置 <code>trigger</code>属性控制子节点的展示方式。可选值 <code>click</code> <code>hover</code>,默认为<code>click</code>。</p>
</template>
                <template slot="title">不同的触发方式 <a href="#BTDCFFS" data-title="不同的触发方式">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    value: {{value}}
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot; trigger=&quot;hover&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="XZJGB">
                <template slot="description"><p>设置 <code>change-on-select</code>属性可以实现不必须选择叶子节点，所有节点都可选择。</p>
</template>
                <template slot="title">选择即改变 <a href="#XZJGB" data-title="选择即改变">#</a></template>
                <template slot="source"><monkey-view-demo6 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    value: {{value}}
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot; change-on-select&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="DTSJJZ">
                <template slot="description"><p>设置 <code>load-data</code>属性实现动态的数据加载。返回Promise，值为该项的children数组。</p>
</template>
                <template slot="title">动态数据加载 <a href="#DTSJJZ" data-title="动态数据加载">#</a></template>
                <template slot="source"><monkey-view-demo7 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Cascader v-model=&quot;valueSearch&quot; :data=&quot;data&quot; :load-data=&quot;handleLoadData&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                valueSearch: [],
                data:  [
                      {
                          value: 'beijing',
                          label: '北京',
                      },
                      {
                          value: 'henan',
                          label: '河南',
                      },
                ]
            }
        },
        methods: {
            handleLoadData(item){
                let result = [];
                if(item.value === 'beijing'){
                    result = [
                        {
                            value: 'haidian',
                            label: '海淀区',
                            last: true,
                        },
                        {
                            value: 'chaoyang',
                            label: '朝阳区',
                            last: true,
                        },
                        {
                            value: 'changping',
                            label: '昌平区',
                            last: true,
                        }
                    ]
                }else if(item.value === 'henan'){
                    result = [
                        {
                            value: 'xuchang',
                            label: '许昌市',
                            children: [
                                {
                                    value: 'xiangchengxian',
                                    label: '襄城县',
                                    last: true,
                                },
                                {
                                    value: 'xuchangxian',
                                    label: '许昌县',
                                    last: true,
                                },
                                {
                                    value: 'linyingxian',
                                    label: '临颍县',
                                    last: true,
                                }
                            ]
                        },
                        {
                            value: 'pingdingshan',
                            label: '平顶山市',
                            last: true,
                        },                    
                    ]               
                }
                return new Promise((resolve, reject) =&gt; {
                    setTimeout(()=&gt;{
                        resolve(result)
                    }, 3000)
                });
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="GSHSJXDZS">
                <template slot="description"><p>设置 <code>format-label</code>属性可自定义数据项的展示内容，类型<code>Function</code>, 返回值为字符串。</p>
</template>
                <template slot="title">格式化数据项的展示 <a href="#GSHSJXDZS" data-title="格式化数据项的展示">#</a></template>
                <template slot="source"><monkey-view-demo8 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot; :format-label=&quot;handleFormatLabel&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {
            handleFormatLabel(item){
                let count = 0;
                if(item.children &amp;&amp; item.children.length){
                    count = item.children.length;
                }
                return `${item.label} (${count})`;
            },
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDYZS">
                <template slot="description"><p>设置 <code>format</code>属性可自定义展示内容，类型<code>Function</code>, 返回值为字符串。</p>
</template>
                <template slot="title">自定义展示 <a href="#ZDYZS" data-title="自定义展示">#</a></template>
                <template slot="source"><monkey-view-demo9 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Cascader v-model=&quot;valueSearch&quot; :data=&quot;data&quot; :format=&quot;handleFormat&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                valueSearch: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {
            handleFormat(labels, selectedData){
                return labels.join('-');
            },
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="SJJZZ">
                <template slot="description"><p>设置 <code>loading</code>属性实现数据加载中的显示，子项的数据加载请使用<code>load-data</code>实现。</p>
</template>
                <template slot="title">数据加载中 <a href="#SJJZZ" data-title="数据加载中">#</a></template>
                <template slot="source"><monkey-view-demo10 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Button @click=&quot;handleLoading&quot; type=&quot;primary&quot;&gt;开启数据加载&lt;/Button&gt;
    &lt;div style=&quot;height: 10px;&quot;&gt;&lt;/div&gt;
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot; :loading=&quot;loading&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                loading: false,
                value: [],
                data:  []
            }
        },
        mounted(){
            this.handleLoading();
        },
        methods: {
            handleLoading(){
                this.loading = true;
                this.data = [];
                setTimeout(()=&gt;{
                    this.data = [
                        {
                            value: 'beijing',
                            label: '北京',
                        },
                        {
                            value: 'henan',
                            label: '河南',
                        },
                    ];
                    this.loading = false;
                }, 3000)  
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="KSS">
                <template slot="description"><p>设置 <code>filterable</code>属性实现可搜索模式。</p>
</template>
                <template slot="title">可搜索 <a href="#KSS" data-title="可搜索">#</a></template>
                <template slot="source"><monkey-view-demo11 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    value: {{value}}
    &lt;Cascader v-model=&quot;value&quot; filterable :data=&quot;data&quot;&gt;&lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="DDSYMB">
                <template slot="description"><p><code>panel</code>面板可以自己单独使用。</p>
</template>
                <template slot="title">单独使用Panel面板 <a href="#DDSYMB" data-title="单独使用Panel面板">#</a></template>
                <template slot="source"><monkey-view-demo12 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    value: {{value}}
    &lt;br&gt;
    &lt;CascaderPanel v-model=&quot;value&quot; :data=&quot;data&quot;&gt;&lt;/CascaderPanel&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDYCFYS">
                <template slot="description"><p>通过<code>slot</code>可以自定义触发元素。</p>
</template>
                <template slot="title">自定义触发元素 <a href="#ZDYCFYS" data-title="自定义触发元素">#</a></template>
                <template slot="source"><monkey-view-demo13 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;p&gt;value: {{value}}&lt;/p&gt;
    &lt;p&gt;label: {{label}}&lt;/p&gt;
    &lt;Cascader v-model=&quot;value&quot; :data=&quot;data&quot; @change=&quot;handleChange&quot;&gt;
        &lt;Button type=&quot;text&quot;&gt;选择&lt;/Button&gt;
    &lt;/Cascader&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                value: [],
                label: '未选择',
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {
            handleChange(value, selectedData){
                this.label = selectedData.map( i =&gt; i.label ).join(' / ');
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="cascader-props" class="anchor-title">Cascader props <a class="header-anchor" href="#cascader-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>Array</td>
<td>绑定的值，可以使用v-model进行双向绑定。数组类型。值的顺序为父级-子级的关系。</td>
<td>-</td>
</tr>
<tr>
<td>data</td>
<td>Array</td>
<td>数据。属性<code>value</code> <code>label</code> <code>disabled</code> <code>last</code>(当前是否为叶子节点，在动态加载数据时判断是否可加载子项)</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>禁用</td>
<td>-</td>
</tr>
<tr>
<td>placeholder</td>
<td>String</td>
<td>占位文本</td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td>String</td>
<td>尺寸，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置</td>
<td>-</td>
</tr>
<tr>
<td>transition</td>
<td>String</td>
<td>可自定义下拉框的动画效果</td>
<td>slideUp</td>
</tr>
<tr>
<td>clearable</td>
<td>Boolean</td>
<td>开启清除</td>
<td>-</td>
</tr>
<tr>
<td>loading</td>
<td>Boolean</td>
<td>动态加载数据时只适用于第一层数据加载，动态加载子项数据请使用<code>loadData</code></td>
<td>-</td>
</tr>
<tr>
<td>loadingText</td>
<td>String</td>
<td>数据加载中的显示文本</td>
<td>加载中</td>
</tr>
<tr>
<td>emptyText</td>
<td>String</td>
<td>数据为空时的显示文本</td>
<td>暂无数据</td>
</tr>
<tr>
<td>filterable</td>
<td>Boolean</td>
<td>开始搜索</td>
<td>-</td>
</tr>
<tr>
<td>format</td>
<td>Function</td>
<td>定义如何显示选中的值，参数为labels(选中项的label数组),selectedData(选中项的data数组),返回值为String类型</td>
<td>-</td>
</tr>
<tr>
<td>format-label</td>
<td>Function</td>
<td>定义如何显示label,参数为当前项数据,返回类型为字符串</td>
<td>-</td>
</tr>
<tr>
<td>trigger</td>
<td>String</td>
<td>定义如何触发子项的展开，可选值 <code>click</code> <code>hover</code></td>
<td>click</td>
</tr>
<tr>
<td>changeOnSelect</td>
<td>Boolean</td>
<td>定义改变即选择，可以选择任意节点的数据，不必须是叶子节点的数据</td>
<td>-</td>
</tr>
<tr>
<td>loadData</td>
<td>Function</td>
<td>动态加载数据，参数为当前选择项，返回当前选择项的子项数组，以Promise的形式返回，如果某一项是最后的叶子节点，需要指定<code>last</code>属性为<code>true</code></td>
<td>-</td>
</tr>
<tr>
<td>renderHtml</td>
<td>HTMLElement, Boolean</td>
<td>指定下拉框所在的元素, true时添加到body中</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3 id="cascader-event" class="anchor-title">Cascader event <a class="header-anchor" href="#cascader-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>选择改变后触发，返回当前选中项的value数组、当前选中项的data数组</td>
<td>values，selectedData</td>
</tr>
<tr>
<td>clear</td>
<td>点击清空按钮时触发</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="cascaderpanel-props" class="anchor-title">CascaderPanel props <a class="header-anchor" href="#cascaderpanel-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>Array</td>
<td>绑定的值，可以使用v-model进行双向绑定。数组类型。值的顺序为父级-子级的关系。</td>
<td>-</td>
</tr>
<tr>
<td>data</td>
<td>Array</td>
<td>数据，属性<code>value</code> <code>label</code> <code>disabled</code> <code>last</code>(当前是否为叶子节点，在动态加载数据时判断是否可加载子项)</td>
<td>-</td>
</tr>
<tr>
<td>format-label</td>
<td>Function</td>
<td>定义如何显示label,参数为当前项数据,返回类型为字符串</td>
<td>-</td>
</tr>
<tr>
<td>trigger</td>
<td>String</td>
<td>定义如何触发子项的展开，可选值 <code>click</code> <code>hover</code></td>
<td>click</td>
</tr>
<tr>
<td>changeOnSelect</td>
<td>Boolean</td>
<td>定义改变即选择，可以选择任意节点的数据，不必须是叶子节点的数据</td>
<td>-</td>
</tr>
<tr>
<td>loadData</td>
<td>Function</td>
<td>动态加载数据，参数为当前选择项，返回当前选择项的子项数组，以Promise的形式返回，如果某一项是最后的叶子节点，需要指定<code>last</code>属性为<code>true</code></td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="cascaderpanel-event" class="anchor-title">CascaderPanel event <a class="header-anchor" href="#cascaderpanel-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>选择改变后触发，返回当前选中项的value数组、当前选中项的data数组</td>
<td>values，selectedData</td>
</tr>
</tbody>
</table>
<h3 id="data-props" class="anchor-title">Data props <a class="header-anchor" href="#data-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>String, Number</td>
<td>选项值</td>
<td>-</td>
</tr>
<tr>
<td>label</td>
<td>String, Number</td>
<td>选项显示的内容。默认在无slot内容时显示此项的内容。在通过slot自定义option显示内容时，此项为必填项。默认根据此项进行搜索</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>禁用</td>
<td>-</td>
</tr>
<tr>
<td>last</td>
<td>Boolean</td>
<td>是否是叶子节点</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":10}},[_c('Col',[_c('Cascader',{attrs:{"data":_vm.data},model:{value:(_vm.valueBase),callback:function ($$v) {_vm.valueBase=$$v},expression:"valueBase"}})],1),_vm._v(" "),_c('Col',[_c('Cascader',{model:{value:(_vm.valueBase),callback:function ($$v) {_vm.valueBase=$$v},expression:"valueBase"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                valueBase: [],
                valueBase1: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":10}},[_c('Col',[_c('Cascader',{attrs:{"data":_vm.data,"size":"mini"},model:{value:(_vm.valueSizeMini),callback:function ($$v) {_vm.valueSizeMini=$$v},expression:"valueSizeMini"}})],1),_vm._v(" "),_c('Col',[_c('Cascader',{attrs:{"data":_vm.data,"size":"small"},model:{value:(_vm.valueSizeSmall),callback:function ($$v) {_vm.valueSizeSmall=$$v},expression:"valueSizeSmall"}})],1),_vm._v(" "),_c('Col',[_c('Cascader',{attrs:{"data":_vm.data},model:{value:(_vm.valueSizeDefault),callback:function ($$v) {_vm.valueSizeDefault=$$v},expression:"valueSizeDefault"}})],1),_vm._v(" "),_c('Col',[_c('Cascader',{attrs:{"data":_vm.data,"size":"large"},model:{value:(_vm.valueSizeLarge),callback:function ($$v) {_vm.valueSizeLarge=$$v},expression:"valueSizeLarge"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                valueSizeMini: [],
                valueSizeSmall: [],
                valueSizeDefault: [],
                valueSizeLarge: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":10}},[_c('Col',[_vm._v("\n            value: "+_vm._s(_vm.valueDisabled)+"\n            "),_c('Cascader',{attrs:{"data":_vm.data,"disabled":""},model:{value:(_vm.valueDisabled),callback:function ($$v) {_vm.valueDisabled=$$v},expression:"valueDisabled"}})],1),_vm._v(" "),_c('Col',[_vm._v("\n            value: "+_vm._s(_vm.valueDisabled1)+"\n            "),_c('Cascader',{attrs:{"data":_vm.data},model:{value:(_vm.valueDisabled1),callback:function ($$v) {_vm.valueDisabled1=$$v},expression:"valueDisabled1"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                valueDisabled: [],
                valueDisabled1: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        disabled: true,
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                        disabled: true,
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    value: "+_vm._s(_vm.value)+"\n    "),_c('Cascader',{attrs:{"data":_vm.data,"clearable":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    value: "+_vm._s(_vm.value)+"\n    "),_c('Cascader',{attrs:{"data":_vm.data},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: ['beijing', 'haidian'],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    value: "+_vm._s(_vm.value)+"\n    "),_c('Cascader',{attrs:{"data":_vm.data,"trigger":"hover"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    value: "+_vm._s(_vm.value)+"\n    "),_c('Cascader',{attrs:{"data":_vm.data,"change-on-select":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Cascader',{attrs:{"data":_vm.data,"load-data":_vm.handleLoadData},model:{value:(_vm.valueSearch),callback:function ($$v) {_vm.valueSearch=$$v},expression:"valueSearch"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                valueSearch: [],
                data:  [
                      {
                          value: 'beijing',
                          label: '北京',
                      },
                      {
                          value: 'henan',
                          label: '河南',
                      },
                ]
            }
        },
        methods: {
            handleLoadData(item){
                let result = [];
                if(item.value === 'beijing'){
                    result = [
                        {
                            value: 'haidian',
                            label: '海淀区',
                            last: true,
                        },
                        {
                            value: 'chaoyang',
                            label: '朝阳区',
                            last: true,
                        },
                        {
                            value: 'changping',
                            label: '昌平区',
                            last: true,
                        }
                    ]
                }else if(item.value === 'henan'){
                    result = [
                        {
                            value: 'xuchang',
                            label: '许昌市',
                            children: [
                                {
                                    value: 'xiangchengxian',
                                    label: '襄城县',
                                    last: true,
                                },
                                {
                                    value: 'xuchangxian',
                                    label: '许昌县',
                                    last: true,
                                },
                                {
                                    value: 'linyingxian',
                                    label: '临颍县',
                                    last: true,
                                }
                            ]
                        },
                        {
                            value: 'pingdingshan',
                            label: '平顶山市',
                            last: true,
                        },                    
                    ]               
                }
                return new Promise((resolve, reject) => {
                    setTimeout(()=>{
                        resolve(result)
                    }, 3000)
                });
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo8": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Cascader',{attrs:{"data":_vm.data,"format-label":_vm.handleFormatLabel},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {
            handleFormatLabel(item){
                let count = 0;
                if(item.children && item.children.length){
                    count = item.children.length;
                }
                return `${item.label} (${count})`;
            },
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo9": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Cascader',{attrs:{"data":_vm.data,"format":_vm.handleFormat},model:{value:(_vm.valueSearch),callback:function ($$v) {_vm.valueSearch=$$v},expression:"valueSearch"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                valueSearch: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {
            handleFormat(labels, selectedData){
                return labels.join('-');
            },
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo10": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.handleLoading}},[_vm._v("开启数据加载")]),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('Cascader',{attrs:{"data":_vm.data,"loading":_vm.loading},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                loading: false,
                value: [],
                data:  []
            }
        },
        mounted(){
            this.handleLoading();
        },
        methods: {
            handleLoading(){
                this.loading = true;
                this.data = [];
                setTimeout(()=>{
                    this.data = [
                        {
                            value: 'beijing',
                            label: '北京',
                        },
                        {
                            value: 'henan',
                            label: '河南',
                        },
                    ];
                    this.loading = false;
                }, 3000)  
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo11": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    value: "+_vm._s(_vm.value)+"\n    "),_c('Cascader',{attrs:{"filterable":"","data":_vm.data},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo12": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_vm._v("\n    value: "+_vm._s(_vm.value)+"\n    "),_c('br'),_vm._v(" "),_c('CascaderPanel',{attrs:{"data":_vm.data},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo13": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('p',[_vm._v("value: "+_vm._s(_vm.value))]),_vm._v(" "),_c('p',[_vm._v("label: "+_vm._s(_vm.label))]),_vm._v(" "),_c('Cascader',{attrs:{"data":_vm.data},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('Button',{attrs:{"type":"text"}},[_vm._v("选择")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                value: [],
                label: '未选择',
                data:  [
                    {
                        value: 'beijing',
                        label: '北京',
                        children: [
                           {
                               value: 'haidian',
                               label: '海淀区',
                           },
                           {
                               value: 'chaoyang',
                               label: '朝阳区',
                           },
                           {
                               value: 'changping',
                               label: '昌平区',
                           }
                        ]
                    },
                    {
                        value: 'henan',
                        label: '河南',
                        children: [
                            {
                                value: 'xuchang',
                                label: '许昌市',
                                children: [
                                    {
                                        value: 'xiangchengxian',
                                        label: '襄城县',
                                    },
                                    {
                                         value: 'xuchangxian',
                                         label: '许昌县',
                                    },
                                    {
                                        value: 'linyingxian',
                                        label: '临颍县',
                                    }
                                ]
                            },
                            {
                                value: 'pingdingshan',
                                label: '平顶山市',
                            },
                        ]
                    },
                ]
            }
        },
        methods: {
            handleChange(value, selectedData){
                this.label = selectedData.map( i => i.label ).join(' / ');
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  